/**
 * Module-level mouse position tracker.
 * Starts tracking as soon as the module is imported.
 * Available before any component mounts.
 */
export const mousePosition = { x: 0, y: 0 }

if (typeof window !== 'undefined') {
  window.addEventListener(
    'mousemove',
    (e: MouseEvent) => {
      mousePosition.x = e.clientX
      mousePosition.y = e.clientY
    },
    { passive: true },
  )
}
